var React = require('react');
var DefaultLayout = require('./common/layout');
import { Form, FormGroup, Col, ControlLabel, Button } from 'react-bootstrap';
import { CenteredDiv } from './common/basic';
import { FControl, CheckBox } from './common/forms';
import '../public/less/login.less';

const loginForm = React.createClass({
    submitForm: function () {
        this
            ._submit
            .click();
    },

    render: function () {
        var errorMsg = "";
        if (this.props.location.query.m == "wrong")
            errorMsg = "Wrong email or password.";
        return (
            <div className='loginBackground'>
                <div className='loginContainer'>
                    <Form horizontal method="post" formAction="login" autoComplete="off">
                        <div className='loginHeader'>
                            <div className='loginLogo'></div>
                            <div className='loginFormContainer'>
                                <h2>Log In</h2>
                                <label className="error">Please confirm the code sent to your phone:</label>

                                <FormGroup>
                                    <input type="text" placeholder="Code" name="Code" id="Code" className="form-control" />
                                </FormGroup>

                                <FormGroup>
                                    <label className="error">{errorMsg}</label>
                                </FormGroup>
                            </div>
                        </div>
                        <input
                            type='submit'
                            className='hidden'
                            ref={(submit) => {
                                this._submit = submit;
                            }} />
                        <label className='submit' onClick={this.submitForm}>LOG IN</label>
                    </Form>
                </div>
            </div>
        )
    }
});

module.exports = loginForm;


// WEBPACK FOOTER //
// ./modules/OTP.jsx